import React, { useEffect } from "react";
import { Form, Typography } from "antd";
import { SettingsDataSelect } from "../forms/AutoCompleteFormItem";
import { InputItem } from "../forms/FormItems";
import CheckBoxItem from "../forms/CheckBoxItem";
import OncallSelector from "./OncallSelector";
import { FormattedMessage } from "react-intl";
import { useEmployees_tariffs } from "../../hooks";

const { Title, Text } = Typography;
const EmployeeWage = (props) => {
  const {
    type,
    activeEvent,
    onTariffChanged,
    onUseEmployeeTariffChanged,
    onTransportationChanged,
    onOncallChange,
    readonly,
  } = props;
  const [form] = Form.useForm();
  const tariffs = useEmployees_tariffs();

  useEffect(() => {
    form.setFieldsValue({
      ...activeEvent,
    });
  }, [activeEvent]);

  useEffect(() => {
    if (
      //handles scenario when employee default tariff was changed by setting his current one incase use_employee_tariff is true
      activeEvent.use_employee_tariff === true &&
      activeEvent?.employee?.tariff?.id !== activeEvent?.tariff_id
    ) {
      onUseEmployeeTariffChanged(true);
    }
  }, [activeEvent]);

  const onValuesChange = (changedValues, allValues) => {
    if (Object.keys(changedValues)[0] === "tariff_id") {
      onTariffChanged(changedValues["tariff_id"]);
    }
    if (Object.keys(changedValues)[0] === "use_employee_tariff") {
      onUseEmployeeTariffChanged(changedValues["use_employee_tariff"]);
    }

    if (Object.keys(changedValues)[0] === "transportation_cost") {
      onTransportationChanged(changedValues["transportation_cost"]);
    }
  };

  const activeTariffFilter = {
    $and: [
      {
        $or: activeEvent.tariff_id
          ? [{ active: true }, { id: activeEvent.tariff_id }]
          : [{ active: true }],
      },
    ],
  };

  const client_salary_tariff_id = activeEvent?.order?.client?.salary_tariff_id;
  const client_salary_tariff = tariffs.find(
    (i) => i.id === client_salary_tariff_id
  );
  const tariff = client_salary_tariff || activeEvent.employee?.tariff;
  return (
    <div className="wage">
      <Title level={4}>
        {<FormattedMessage id="app.scheduling.employeeSettings" />}
      </Title>
      <div className="divider" />

      <Form layout="vertical" onValuesChange={onValuesChange} form={form}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1 }}>
            <SettingsDataSelect
              name="tariff_id"
              category="employee"
              settingsdataName={"tariffs"}
              required={!activeEvent?.use_employee_tariff}
              disabled={
                readonly ||
                !activeEvent.employee_id ||
                activeEvent.use_employee_tariff
              }
              extraParams={{
                filter: activeTariffFilter,
              }}
              type="list"
            />
          </div>
          <div style={{ width: "20px" }} />
          <div style={{ flex: 1 }}>
            <InputItem
              name="transportation_cost"
              category="employee"
              number={true}
              disabled={readonly}
              twoDigitsNumbers={true}
              onlyPositiveNumbers={true}
              style={{ margin: 0 }}
            />
            {activeEvent &&
              activeEvent.employee &&
              activeEvent.employee.transportation_cost_strategy && (
                <Text>
                  {
                    <FormattedMessage
                      id={`app.forms.employee.${activeEvent.employee.transportation_cost_strategy}`}
                    />
                  }
                </Text>
              )}
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div style={{ flex: 1 }}>
            {tariff && (
              <>
                <CheckBoxItem
                  name="use_employee_tariff"
                  category="employee"
                  style={{ marginBottom: 0 }}
                  disabled={readonly}
                />
                <Text
                  ellipsis={{ tooltip: `${tariff?.name} (${tariff?.cost})` }}
                  style={{
                    display: "block",
                    width: "160px",
                    paddingRight: "24px",
                  }}
                >
                  {`${tariff?.name} (${tariff?.cost})`}
                </Text>
              </>
            )}
          </div>
          <div style={{ width: "20px" }} />
          <div style={{ flex: 1 }}>
            {type !== "plan" && (
              <OncallSelector
                onOncallChange={onOncallChange}
                activeEvent={activeEvent}
              />
            )}
          </div>
        </div>
      </Form>
    </div>
  );
};

export default EmployeeWage;
